import React from "react";
import { Col, Row, Typography, Skeleton, Image } from "antd";
import { useTranslation } from "react-i18next";
import fastImage from "../../Image/fast.png";
import lock from "../../Image/lock.png";
import exchnage from "../../Image/exchange.png";
import customer from "../../Image/customer.png";
import easy from "../../Image/easy.png";
const { Text } = Typography;
const HomePagePart2 = () => {
  const { t, i18n } = useTranslation();
  const features = [
    {
      title: "Fast",
      description: "Experience lightning-speed transactions. With our cutting-edge technology, your money  is transferred within minutes.",
      imageName: "fast",
    },
    {
      title: "Secure",
      description: "Your trust is our top priority. Our robust security measures guarantee the safety of  your transaction, giving you peace of mind.",
      imageName: "lock",
    },
    {
      title: "Best Rates",
      description: "We provide the most competitive exchange rates, ensuring you get more value  for every dollar sent.",
      imageName: "exchnage",
    },
    {
      title: "Smooth User Experience",
      description: "Our platform is user-friendly and efficient, making your remittance  experience hassle-free.",
      imageName: "easy",
    },
    {
      title: "Excellent Customer Service",
      description: "Our dedicated team is here to support you every step of the  way, ensuring a seamless transaction process.",
      imageName: "customer",
    },
  ];
  const getImageSources = (imageName) => {
    const images = {
      fast: fastImage,
      lock: lock,
      exchnage: exchnage,
      easy: easy,
      customer: customer,
    };

    return images[imageName];
  };
  return (
    <div style={{ padding: "2rem 0rem" }}>
      <div
        style={{
          textAlign: "center",
          marginTop: "2rem",
          marginBottom: "3rem",
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <h2
          style={{
            fontWeight: "normal",
            paddingBottom: 20,
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          Welcome to BajCan, the most reliable and cost-effective way to send money between Canada and Barbados.
          {/* {t("homeP2.title")} */}
        </h2>
        <h3 style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20 }}>
        We understand how important it is to ensure your hard-earned money  reaches its destination safely and quickly. That's why we offer a service that is
        {/* {t("homeP2.subtitle")} */}
        </h3>
      </div>

      <div>
        <Row
          style={{
            padding: "0rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {features.map((feature) => (
            <Col
              xs={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 4 }}
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "2rem",
              }}
              key={feature.title} // Assuming each title is unique
            >
              <div style={{ width: "70%", textAlign: "center" }}>
                <Image
                  active
                  preview={false} // Disable preview on hover
                  width={"70px"}
                  src={getImageSources(feature.imageName)}
                />
                <h4>{t(feature.title)}</h4>
                <Text>{t(feature.description)}</Text>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};
export default HomePagePart2;
